// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3I23j","icon":"SortAdornment_icon__34AMg","up":"SortAdornment_up__lheGQ","down":"SortAdornment_down__2ofYW","active":"SortAdornment_active__2CMsm"};